import React, { useId } from 'react';
import { COLORWAYS, ICON, svgId } from '@/lib/synexLogo';

/**
 * The Synex X mark (the brand's icon). Its gradient's id is unique to each
 * copy unless `gradientId` names one: a url(#id) resolves to the first
 * element with that id, so a hidden first copy would leave every other mark
 * without its gradient.
 */
export default function ApplicationIcon({ gradientId, colorway = 'primary', ...props }) {
  const ownId = svgId('synex-icon', useId());
  const id = gradientId ?? ownId;
  const { ink, from, to } = COLORWAYS[colorway];

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${ICON.size} ${ICON.size}`} fill="none" {...props}>
      <path fill={ink} d={ICON.bar} />
      <path fill={`url(#${id})`} d={ICON.sweep} />
      <defs>
        <linearGradient id={id} {...ICON.gradient} gradientUnits="userSpaceOnUse">
          <stop stopColor={from} />
          <stop offset="1" stopColor={to} />
        </linearGradient>
      </defs>
    </svg>
  );
}
